import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface DateFilterDialogData {
  operator: string;
  from: Date | null;
  to?: Date | null;
  filterOptions: string[];
}

@Component({
  selector: 'app-date-filter-dialog',
  standalone: false,
  templateUrl: './date-filter-dialog.component.html',
})
export class DateFilterDialogComponent {
  operator: string;
  from: Date | null;
  to: Date | null;
  filterOptions: string[];

  constructor(
    private dialogRef: MatDialogRef<DateFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DateFilterDialogData,
  ) {
    this.operator = data.operator;
    this.from = data.from;
    this.to = data.to || null;
    this.filterOptions = data.filterOptions;
  }

  onApply(): void {
    this.dialogRef.close({
      operator: this.operator,
      from: this.from,
      to: this.operator === 'inRange' ? this.to : null,
    });
  }

  formatLabel(option: string): string {
    switch (option) {
      case 'equals':
        return 'Equals';
      case 'inRange':
        return 'In Range';
      case 'lessThan':
        return 'Less than';
      case 'greaterThan':
        return 'Greater than';
      default:
        return option;
    }
  }

  onClear(): void {
    this.operator = 'inRange';
    this.from = null;
    this.to = null;
  }
}
